module.exports = __webpack_public_path__ + "static/media/ic_ticket_board_blue.ecef44ad.svg";